import { getOwner } from '@ember/application';
import Route from 'cio/routes/base';
import Service from '@ember/service';
import { Dirtyable, ConfirmChangesInstance } from 'cio/utils/confirm-changes';

export default class ConfirmChangesService extends Service {
  private instances: ConfirmChangesInstance[] = [];

  private addManager(manager: ConfirmChangesInstance) {
    this.instances = [...this.instances, manager];
  }

  removeManager(manager: ConfirmChangesInstance) {
    this.instances = this.instances.filter((instance) => instance !== manager);
  }

  hasManagers() {
    return this.instances.length !== 0;
  }

  getManagerInstance() {
    if (!this.hasManagers()) {
      return null;
    }

    return this.instances[0];
  }

  register(dirtyable: Dirtyable, dirtyableRoute?: Route) {
    let owner = getOwner(dirtyable);

    if (owner == null) {
      throw new Error(
        'You attempted to register an object with the ConfirmChanges service without an owner. This util can only be used with objects that have an owner (route, controller, components, etc.)',
      );
    }

    let manager = new ConfirmChangesInstance(owner, dirtyable, dirtyableRoute);

    this.addManager(manager);

    return manager;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'confirm-changes': ConfirmChangesService;
  }
}
